// Bold two-building "office" mark, solid-filled with true cut-out windows
// (fill-rule evenodd) so it reads as a real logomark, not a thin UI icon.
function OrgAdminLogo() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="
          M4.5 4.5 H11.5 V21 H4.5 Z
          M13 9.5 H19.5 V21 H13 Z
          M7 7 H9 V9.2 H7 Z
          M7 11.2 H9 V13.4 H7 Z
          M7 15.4 H9 V17.6 H7 Z
          M14.7 12.2 H16.5 V14.2 H14.7 Z
          M14.7 16.2 H16.5 V18.2 H14.7 Z
        "
        fill="currentColor"
      />
    </svg>
  );
}

export default OrgAdminLogo;
